import { SearchParamKey } from '@app/store/appStore.types'

// Origin params are session-scoped: they live for the current auth session only and
// are cleared once the user leaves for the product (see clearOriginParams).
// login_origin_domain and signup_origin_domain are kept separate and never mixed.
export const ORIGIN_SEARCH_PARAMS = [
    SearchParamKey.LOGIN_ORIGIN_DOMAIN,
    SearchParamKey.SIGNUP_ORIGIN_DOMAIN,
    SearchParamKey.SIGNUP_ORIGIN_PATH,
]

export const SESSION_SEARCH_PARAMS = [
    SearchParamKey.ACCESS_TOKEN,
    SearchParamKey.REFRESH_TOKEN,
    SearchParamKey.REDIRECT_URL,
    ...ORIGIN_SEARCH_PARAMS,
]

export const PERSISTENT_SEARCH_PARAMS = [
    SearchParamKey.COMPANY_INVITE_ID,
    SearchParamKey.REF_CODE,
]

// Captured once on landing on /sign-up* and persisted (localStorage) across every
// step of the multi-step signup flow, even once the query params are gone from the URL.
export const SIGNUP_ATTRIBUTION_SEARCH_PARAMS = [
    SearchParamKey.LANDING_PAGE,
    SearchParamKey.REFERRER,
    SearchParamKey.UTM_SOURCE,
    SearchParamKey.UTM_MEDIUM,
    SearchParamKey.UTM_CAMPAIGN,
    SearchParamKey.UTM_CONTENT,
    SearchParamKey.UTM_TERM,
]
